import React, { memo, useMemo } from "react"
import PropTypes from "prop-types"
import MDBDataTable from "../../components/Common/MDBDataTable"
import { Row, Col, Card, CardBody, CardTitle, Spinner } from "reactstrap"
import "../Shoppers/datatables.scss"

/**
 * Default entries options for pagination
 */
const DEFAULT_ENTRIES_OPTIONS = [10, 20, 30, 40, 60, 80, 100, 200, 500, 1000];

/**
 * Default info label for table pagination
 */
const DEFAULT_INFO_LABEL = ["Showing", "to", "of", "records"];

/**
 * Renders loading spinner
 */
const LoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner color="primary" />
    </div>
);

/**
 * Renders the table header with title
 */
const TableHeader = ({ title }) => (
    <CardTitle className="bg-light border-bottom p-3 mb-0">
        <i className="mdi mdi-account-group-outline font-18 mr-2"></i> {title}
    </CardTitle>
);

TableHeader.propTypes = {
    title: PropTypes.string,
}

const MerchantsList = memo(({
    data,
    option = DEFAULT_ENTRIES_OPTIONS,
    default_entries = 20,
    displayEntries = true,
    searching = true,
    title = "Stores List",
    paging = true,
    loading = false
}) => {
    const dataTableProps = useMemo(() => ({
        responsive: true,
        bordered: true,
        entriesOptions: option,
        data: data,
        entries: default_entries,
        displayEntries: displayEntries,
        searching: searching,
        infoLabel: DEFAULT_INFO_LABEL,
        paging: paging,
        sortable: true
    }), [option, data, default_entries, displayEntries, searching, paging]);

    return (
        <Row>
            <Col className="col-12">
                <Card>
                    <TableHeader title={title} />
                    <CardBody>
                        {loading ? (
                            <LoadingSpinner />
                        ) : (
                            <MDBDataTable {...dataTableProps} />
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
});

MerchantsList.propTypes = {
    data: PropTypes.shape({
        columns: PropTypes.arrayOf(PropTypes.object),
        rows: PropTypes.arrayOf(PropTypes.object),
    }),
    option: PropTypes.arrayOf(PropTypes.number),
    default_entries: PropTypes.number,
    displayEntries: PropTypes.bool,
    searching: PropTypes.bool,
    title: PropTypes.string,
    paging: PropTypes.bool,
    loading: PropTypes.bool,
}

MerchantsList.displayName = 'MerchantsList';

export default MerchantsList
